import React from 'react';

const MenuDivider = () => (
  <div
    style={{
      flexGrow: 1,
      height: '2px',
      backgroundColor: 'var(--color-brand)',
      margin: '0 10px',
    }}
  />
);

export default MenuDivider;
